/**
 * @param {number} blow - pitch of the blow note
 * @param {number} draw - pitch of the draw note
 * @returns {number[]}
 */
function overblowsFrom (blow, draw) {
  if (blow > draw) { return null }
  return [draw + 1]
}

/**
 * @param {number} blow - pitch of the blow note
 * @param {number} draw - pitch of the draw note
 * @returns {number[]}
 */
function overdrawsFrom (blow, draw) {
  if (draw > blow) { return null }
  return [blow + 1]
}

/**
 * @param {number} blow - pitch of the blow note
 * @param {number} draw - pitch of the draw note
 * @returns {number[]}
 */
function drawbendsFrom (blow, draw) {
  if (blow > draw) { return null }
  const length = draw - blow - 1
  return [...Array(length).keys()].map(x => draw - x - 1)
}

/**
 * @param {number} blow - pitch of the blow note
 * @param {number} draw - pitch of the draw note
 * @returns {number[]}
 */
function blowbendsFrom (blow, draw) {
  if (draw > blow) { return null }
  const length = blow - draw - 1
  return [...Array(length).keys()].map(x => blow - x - 1)
}

/** Class representing a diatonic harmonica hole */
export class HarmonicaHole {
  /**
   * Create a harmonica
   * @param {number} blow - pitch of the blow note
   * @param {number} draw - pitch of the draw note
   */
  constructor (blow, draw) {
    this.blow = blow
    this.draw = draw
    this.overblows = overblowsFrom(blow, draw)
    this.overdraws = overdrawsFrom(blow, draw)
    this.naturalBlowBends = blowbendsFrom(blow, draw)
    this.naturalDrawBends = drawbendsFrom(blow, draw)
    this.blowBends = this.naturalBlowBends || this.overblows
    this.drawBends = this.naturalDrawBends || this.overdraws
  }

  /** @return `true` if the  hole has at least 1 overblow */
  hasOverblows () { return this.overblows && this.overblows > 0 }
  /** @return `true` if the  hole has at least 1 overdraw */
  hasOverdraws () { return this.overdraws && this.overdraws > 0 }
  /** @returns {number} the maximum number of traditional blow bends or overblows */
  maxBlowbends () {
    let note = this
    const nbOverblows = note.overblows ? note.overblows.length : 0
    const nbblowbends = note.naturalBlowBends ? note.naturalBlowBends.length : 0
    return Math.max(nbOverblows, nbblowbends)
  }
  /** @returns {number} the  maximum number of traditional draw bends or overdraw */
  maxDrawbends () {
    let note = this
    const nbOverdraws = note.overdraws ? note.overdraws.length : 0
    const nbDrawbends = note.naturalDrawBends ? note.naturalDrawBends.length : 0
    return Math.max(nbOverdraws, nbDrawbends)
  }
}

export function fromPattern (pattern, harpKey) {
  if (!pattern) { return { holes: [] } }
  const size = pattern.blow.length
  let holes = []
  for (let i = 0; i < size; i++) {
    holes.push(new HarmonicaHole(pattern.blow[i] + harpKey, pattern.draw[i] + harpKey))
  }
  return {
    holes,
    maxBlowbends () {
      return this.holes
        .map(x => x.maxBlowbends())
        .reduce((a, b) => Math.max(a, b), 0)
    },
    maxDrawbends () {
      return this.holes
        .map(x => x.maxDrawbends())
        .reduce((a, b) => Math.max(a, b), 0)
    }
  }
}



// WEBPACK FOOTER //
// ./src/harmonica.js